const MM_TO_PIXEL = 12;
const FONT_SIZE_MULTIPLIER = 4;
const FINAL_IMAGE_WIDTH = 594; // 50.26mm en 300dpi
const FINAL_IMAGE_HEIGHT = 3602; // 305mm en 300dpi
const IMG_WIDTH = 50.26; // mm
const IMG_HEIGHT = 305; // mm
const MARGIN_TOP = 236; // 16 inside + 4 biseau = 20mm en 300dpi
const MARGIN_BOTTOM = 236; // 16 inside + 6 biseau - 2 decal printing zone = 20mm en 300dpi
const STICKER_POSITION_BOTTOM = 343; // 29mm en 300dpi
const GUIDETTI_STICKER_WIDTH = 512; // 31.6mm en 300dpi
const GUIDETTI_STICKER_HEIGHT = 201; // 28mm en 300dpi
const BAT_SCALE_FACTOR = 1;
const BAT_DPI = 300 * BAT_SCALE_FACTOR;
const WARNING_MINIMUM_DPI = 200;
const MIN_ZOOM = 0;
const MAX_ZOOM = 3;

export {
    MM_TO_PIXEL,
    FONT_SIZE_MULTIPLIER,
    FINAL_IMAGE_WIDTH,
    FINAL_IMAGE_HEIGHT,
    MARGIN_TOP,
    MARGIN_BOTTOM,
    BAT_SCALE_FACTOR,
    BAT_DPI,
    WARNING_MINIMUM_DPI,
    IMG_WIDTH,
    IMG_HEIGHT,
    STICKER_POSITION_BOTTOM,
    GUIDETTI_STICKER_WIDTH,
    GUIDETTI_STICKER_HEIGHT,
    MIN_ZOOM,
    MAX_ZOOM,
};
